module.exports = __webpack_public_path__ + "img/69600.d0dc789f.jpg";